<template>
  <CModal
    :show="show"
    :closeOnBackdrop="true"
    :centered="true"
    size="lg"
    @update:show="$emit('update:show', $event)"
  >
    <template #header>
      <h5 class="modal-title">Letzte Bestellung</h5>
      <p v-if="order && order.view" class="ui-type-subheading">
        Bestellung #{{ order.id }} - {{ currencySymbol }}
        {{ order.view.tot_price.toFixed(2) }} -
        {{ new Date(order.ddmi.delivery_date).toLocaleDateString() }}
      </p>
    </template>

    <div
      v-if="order && order.details && order.details.length > 0"
      class="bg-white rounded border"
    >
      <table class="table table-sm mb-0 border-0 table-striped align-middle">
        <thead>
          <tr class="border-0">
            <th class="p-2 border-bottom-1">Produkt</th>
            <th class="p-2 border-bottom-1 text-right">Bestellung</th>
            <th class="p-2 border-bottom-1 text-right">Warenkorb</th>
            <th class="p-2 border-bottom-1 text-right"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="border-0"
            v-for="(item, index) in order.details"
            :key="index"
          >
            <td class="px-2 border-0">
              {{
                item.ppm.lot.productproducer.producer.role.name +
                " - " +
                getProductName(item)
              }}
            </td>
            <td class="px-2 border-0 text-right">{{ item.qta }}</td>
            <td class="px-2 border-0 text-right">
              <span v-if="isInCart(item)"
                ><font-awesome-icon
                  icon="check-circle"
                  class="mr-2"
                  color="green"
              /></span>
              <span v-if="!currentCartLoading">{{
                getItemCartQuantity(item)
              }}</span>
              <CSpinner v-else color="gray-300" size="sm" />
            </td>
            <td class="px-2 border-0 text-right">
              <CButton
                v-if="!isInCart(item)"
                color="primary"
                type="submit"
                size="sm"
                @click="addItemToCart(item, false)"
              >
                <font-awesome-icon icon="shopping-cart" />
              </CButton>
              <CButton
                v-if="isInCart(item)"
                color="danger"
                type="submit"
                size="sm"
                @click="addItemToCart(item, true)"
              >
                <font-awesome-icon icon="trash-alt" />
              </CButton>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="text-muted">Keine Details verfügbar.</div>

    <template #footer>
      <CButton
        color="primary"
        variant="outline"
        @click="$emit('update:show', false)"
      >
        Schließen
      </CButton>
    </template>
  </CModal>
</template>

<script>
import get from "lodash/get";
import { apiPost, apiGet } from "../../../helpers/apiHelper";
import { mapGetters } from "vuex";

export default {
  name: "MarketLastOrderModal",

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default: null,
    },
    familyId: {
      type: [String, Number],
      required: true,
    },
    marketId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      currentCart: null,
      currentCartLoading: true,
    };
  },

  computed: {
    lang() {
      return this.$i18n.locale;
    },

    ...mapGetters("connections", ["currencySymbol"]),
  },

  methods: {
    getProductName(item) {
      const translations = get(item, "ppm.lot.translations", {});
      const name = get(translations, `${this.lang}.name`, "");
      if (name) return name;
      // Fallback: first available translation
      const firstKey = Object.keys(translations)[0];
      return firstKey ? get(translations, `${firstKey}.name`, "—") : "—";
    },

    async addItemToCart(item, del = false) {
      let items = {
        ppms: [
          {
            ppm_id: item.ppm.id,
            qta: del ? 0 : item.qta,
          },
        ],
      };

      const response = await apiPost("family_market_current_cart", items, [
        this.familyId,
        this.marketId,
      ]);

      if (response && response.data) {
        this.currentCart = response.data.payload.items;
        this.currentCartLoading = false;

        if (response.data.errors.fields[0].length === 0) {
          this.$store.dispatch("toaster/add", {
            title: "OK!",
            text: this.$t("family.market.showcase.cart.msg_cart_update"),
            color: "success",
            autohide: true,
            delay: 1000,
          });
        } else {
          this.$store.dispatch("toaster/add", {
            title: "Fehler!",
            text: this.$t("family.market.showcase.cart.msg_cart_error"),
            color: "danger",
            autohide: true,
            delay: 1000,
          });
        }
      }
    },

    async getCurrentCart() {
      const response = await apiGet("family_market_current_cart", [
        this.familyId,
        this.marketId,
      ]);

      if (response && response.data && response.data.payload.items.length > 0) {
        this.currentCart = response.data.payload.items;
      }

      this.currentCartLoading = false;
    },

    getItemCartQuantity(item) {
      if (!this.currentCart) return 0;

      const cartItem = this.currentCart.find(
        (cartPpm) => cartPpm.ppm === item.ppm.id
      );
      return cartItem ? cartItem.qta : 0;
    },

    isInCart(item) {
      if (!this.currentCart) return false;
      const cartItem = this.currentCart.find(
        (cartPpm) => cartPpm.ppm === item.ppm.id
      );
      if (cartItem && cartItem.qta === item.qta) {
        return true;
      }
      return false;
    },
  },

  watch: {
    async show(newVal) {
      if (newVal) {
        await this.getCurrentCart();
      }
    },
  },
};
</script>
